import type { Rechtsform } from './types';

// Rechtsformen in „Meine Angaben“ und welche Pflichtangaben dazugehören (wie server/src/modules/rechnungstool/
// pflichtangaben.ts; der Server prüft beim Speichern genauso). register: Sitz, Registergericht, Registernummer.
export interface FormInfo {
  label: string;
  // Rechtsform im Firmennamen (fehlt: keine Vorgabe)
  zusatz: RegExp | null;
  beispiel: string;
  register: 'pflicht' | 'frei' | null;
  hrPrefix: 'HRA' | 'HRB';
  vertretung: null | { label: string; placeholder: string; pflicht: boolean; hint?: string; lang?: boolean };
}

const GF = {
  label: 'Geschäftsführer (alle, mit Vor- und Zunamen)',
  placeholder: 'z. B. Max Mustermann, Erika Musterfrau',
  pflicht: true,
  hint: 'Hat die Firma einen Aufsichtsrat, auch dessen Vorsitz.',
};

export const RECHTSFORMEN: [Rechtsform, FormInfo][] = [
  [
    'einzel',
    {
      label: 'Einzelunternehmen',
      zusatz: null,
      beispiel: '',
      register: null,
      hrPrefix: 'HRA',
      vertretung: { label: 'Inhaber (Vor- und Zuname)', placeholder: 'z. B. Max Mustermann', pflicht: true },
    },
  ],
  [
    'ek',
    {
      label: 'Eingetragener Kaufmann (e. K.)',
      zusatz: /\be\.\s?K(fm|fr)?\.|eingetragene[rn]?\s+Kauf(mann|frau)/i,
      beispiel: 'Muster Handel e. K.',
      register: 'pflicht',
      hrPrefix: 'HRA',
      vertretung: null,
    },
  ],
  [
    'gbr',
    {
      label: 'GbR',
      zusatz: null,
      beispiel: '',
      register: null,
      hrPrefix: 'HRA',
      vertretung: { label: 'Gesellschafter (freiwillig)', placeholder: 'z. B. Max Mustermann, Erika Musterfrau', pflicht: false },
    },
  ],
  [
    'gmbh',
    {
      label: 'GmbH',
      zusatz: /GmbH|\bmbH\b|Gesellschaft\s+mit\s+beschränkter\s+Haftung/i,
      beispiel: 'Muster Bau GmbH',
      register: 'pflicht',
      hrPrefix: 'HRB',
      vertretung: GF,
    },
  ],
  [
    'ug',
    {
      label: 'UG (haftungsbeschränkt)',
      zusatz: /(\bUG|Unternehmergesellschaft)\s*\(haftungsbeschränkt\)/i,
      beispiel: 'Muster Bau UG (haftungsbeschränkt)',
      register: 'pflicht',
      hrPrefix: 'HRB',
      vertretung: GF,
    },
  ],
  [
    'gmbh_co_kg',
    {
      label: 'GmbH & Co. KG',
      zusatz: /(GmbH|mbH|haftungsbeschränkt|\bAG\b)[\s\S]*(\bKG\b|Kommanditgesellschaft)/i,
      beispiel: 'Muster Bau GmbH & Co. KG',
      register: 'pflicht',
      hrPrefix: 'HRA',
      vertretung: {
        label: 'Komplementär-GmbH',
        placeholder: 'z. B. Muster Verwaltungs GmbH, Sitz Hamburg, Amtsgericht Hamburg HRB 12345, Geschäftsführer: Max Mustermann',
        pflicht: true,
        hint: 'Name, Sitz, Registergericht und -nummer der GmbH und ihre Geschäftsführer.',
        lang: true,
      },
    },
  ],
  ['ohg', { label: 'OHG', zusatz: /\bOHG\b|offene\s+Handelsgesellschaft/i, beispiel: 'Muster & Partner OHG', register: 'pflicht', hrPrefix: 'HRA', vertretung: null }],
  ['kg', { label: 'KG', zusatz: /\bKG\b|Kommanditgesellschaft/i, beispiel: 'Muster Bau KG', register: 'pflicht', hrPrefix: 'HRA', vertretung: null }],
  [
    'ag',
    {
      label: 'AG',
      zusatz: /\bAG\b|Aktiengesellschaft/i,
      beispiel: 'Muster AG',
      register: 'pflicht',
      hrPrefix: 'HRB',
      vertretung: {
        label: 'Vorstand und Vorsitz des Aufsichtsrats',
        placeholder: 'z. B. Max Mustermann (Vorsitz), Erika Musterfrau; Aufsichtsratsvorsitz: Hans Huber',
        pflicht: true,
        hint: 'Alle Vorstandsmitglieder mit Vor- und Zunamen, den Vorsitz kennzeichnen.',
        lang: true,
      },
    },
  ],
  [
    'andere',
    {
      label: 'Andere',
      zusatz: null,
      beispiel: '',
      register: 'frei',
      hrPrefix: 'HRB',
      vertretung: { label: 'Vertreten durch (freiwillig)', placeholder: 'z. B. Max Mustermann', pflicht: false },
    },
  ],
];

export const formInfo = (r: Rechtsform | '' | null | undefined) => (r ? RECHTSFORMEN.find(([k]) => k === r)?.[1] : undefined);
